import { OrderType } from '../../providers/request/order-type.enum';
import { ProjectItemType } from '../project/project-item-type.enum';
import { ProjectSectionUnitProgressSearchRequest } from '../project/project-section-unit-progress-search-request.model';

export class JgPhysicalInspUnitSearchRequest extends ProjectSectionUnitProgressSearchRequest {
  jgSectionId?: number;
  dwTypeName?: string;
  dwTypeNameSort?: number;
  dwCodeSort?: number;
  jgFbName?: string;
  jgFbNameSort?: number;
  jgFxName?: string;
  jgFxProjectTypeCode?: string;
  jgFxProjectTypeName?: string;
  type?: ProjectItemType;
  sortOrderOrder?: OrderType;
}
